import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-cuboid-rescale-confirmation-modal',
  templateUrl: './cuboid-rescale-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CuboidRescaleConfirmationModalComponent {}
